import type { ReactNode } from "react";

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  children?: ReactNode;
}

export function BulkActionBar({ count, onClear, children }: BulkActionBarProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap px-4 py-2.5 bg-emerald-50 border border-emerald-100 rounded-lg mb-3">
      <span className="text-sm font-semibold text-emerald-800 whitespace-nowrap">{count} selected</span>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
      <button onClick={onClear} className="ml-auto text-xs font-medium text-slate-500 hover:text-slate-700 whitespace-nowrap">
        Clear selection
      </button>
    </div>
  );
}